<script>
	import {link,push} from 'svelte-spa-router'
	import {getNinjas} from './NinjaAPI.svelte' 
	import {Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,
    NavItem,NavLink,Styles,Input} from 'sveltestrap';
  let isOpen = false;
  function handleUpdate(event) {
    isOpen = event.detail.isOpen;
  }
  let searchText = ""
  function doSearch(){
    if(searchText){
      push('/search/'+searchText)
    }
    
  }
</script>
<Navbar color="light" light expand="md">
	<a href="/" use:link>
		<NavbarBrand>นินจาคาถาโอ้โฮเฮะ</NavbarBrand>
	</a>
  <NavbarToggler on:click={() => (isOpen = !isOpen)} />
  <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
    <Nav class="ms-auto" navbar>

      <NavItem>
				<a href="/about" use:link><NavLink>About</NavLink></a>
      </NavItem>
      <NavItem>
        <form on:submit|preventDefault="{doSearch}">
          <Input bind:value={searchText} type="search" placeholder="พิมพ์ชื่อหรือ all"/>
        </form>
				
      </NavItem>

    </Nav>
  </Collapse>
</Navbar>
<Styles />